import {Component, OnInit, OnChanges, SimpleChanges, EventEmitter, Output, Inject, Input} from '@angular/core';
import {SidenavService} from '../sidenav/sidenav.service';
import {ContractSelectorService} from '../contract-selector-service/contract-selector.service';
import {Program, Cedant, Contract} from '../shared.types';
import {Router} from '@angular/router';
import {MatDialog, MatDialogConfig} from '@angular/material';
import {ModalComponent} from '../modal/modal.component';
import {DOCUMENT} from '@angular/common';
import {ContractSelectorStateService} from '../contract-selector-state-service/contract-selector-state.service';
import {CreateContractComponent} from '../create-contract/create-contract.component';
import {CreateProgramComponent} from '../create-program/create-program.component';

@Component({
  selector: 'contract-selector',
  templateUrl: './contract-selector.component.html',
  styleUrls: ['./contract-selector.component.scss']
})
export class ContractSelectorComponent implements OnInit, OnChanges {

  constructor(@Inject(DOCUMENT) public document: HTMLDocument,
              private sidenav:                   SidenavService,
              private dialog:                    MatDialog,
              private provider:                  ContractSelectorService,
              private router:                    Router,
              public contractSelectorState:      ContractSelectorStateService) { }

  @Output()
  toggleTBCSidenav = new EventEmitter<void>();

  programs:         Program[]  = [];
  selectedProgram:  Program ;

  cedants:          Cedant[]   = [];
  selectedCedant:   Cedant;

  contracts:        Contract[] = [];
  selectedContract: Contract;

  flyoutTitle = 'Title';

  /**
   * TODO: Change this. This is a hack as we have no time to move the pieces properly for the demo
   * @obsolote
   * @memberof ContractSelectorComponent
   */
  @Input('are-actions-hidden')
  areGeneralActionsHidden = false;

  element: HTMLElement;
  /**
   * Toggles the open state   *
   * @memberof ContractSelectorComponent
   */
  toggle() {
    this.contractSelectorState.isExpanded = !this.contractSelectorState.isExpanded;
  }

  ngOnInit() {
    this.provider
        .getAllCedants()
        .subscribe(cedants => {
          this.cedants = cedants;
          this.contractSelectorState.currentCedants = cedants;
        });

    this.contractSelectorState
        .cedant$
        .subscribe( cedant => {
          this.selectedCedant = cedant;
        });

    // this.provider
    //     .getPrograms()
    //     .subscribe(programs => {
    //       this.programs = programs;
    //       this.contractSelectorState.currentPrograms = programs;
    //     });

    // this.contractSelectorState
    //     .program$
    //     .subscribe( p => {
    //       this.selectedProgram = p;
    //     });

    // this.provider
    //     .getContracts()
    //     .subscribe(contracts => {
    //       this.contracts = contracts;
    //       this.contractSelectorState.currentContracts = contracts;
    //     });

    this.contractSelectorState
        .contract$
        .subscribe( c => {
          this.selectedContract = c;
        });
  }

  pickCedant(cedant: Cedant) {
    if (this.selectedCedant) {
      this.selectedCedant.isSelected = false;
    }
    this.selectedCedant = cedant;
    this.selectedCedant.isSelected = true;
    this.contractSelectorState.currentCedant = cedant;
    this.contractSelectorState.setCedantActive();

    // setup programs group
    this.programs = cedant.programs;
    this.contractSelectorState.currentPrograms = cedant.programs;
  }

  pickProgram(program: Program) {
    if (this.selectedProgram) {
      this.selectedProgram.isSelected = false;
    }
    this.selectedProgram = program;
    this.selectedProgram.isSelected = true;

    // setup programs contracts
    this.contracts = program.contracts;
    this.contractSelectorState.currentContracts = program.contracts;

    this.contractSelectorState.currentProgram = program;
    this.contractSelectorState.isExpanded = true;
    this.contractSelectorState.setProgramActive();
  }

  pickContract(contract: Contract) {
    if (this.selectedContract) {
      this.selectedContract.isSelected = false;
    }
    this.selectedContract = contract;
    this.selectedContract.isSelected = true;
    this.router.navigate(['cedant', this.selectedCedant.id || 0, 'program', this.selectedProgram.id || 0, 'contract', contract.id || 0]);
    this.contractSelectorState.currentContract = contract;
    this.contractSelectorState.isExpanded = false;
    this.contractSelectorState.setContractActive();
  }

  ngOnChanges(changes: SimpleChanges) {
  }


  openDialog(title: string) {
    const config = new MatDialogConfig();
    config.data = {title};
    config.minHeight = '400px';
    config.width = '640px';
    this.dialog.open(ModalComponent, config);
  }

  addNewCedant() {
    this.openDialog('New Cedant');
  }

  addNewProgram() {
    const config = new MatDialogConfig();
    config.data = {title: 'New Program'};
    config.minHeight = '400px';
    config.width = '640px';
    config.panelClass = 'create-program';

    const dialogRef = this.dialog.open(CreateProgramComponent, config);

    dialogRef.afterClosed().subscribe(result => {
      if (result.isOk) {
        this.router.navigate(['/cedant/1/program/1']);
      }
    });
  }

  addNewContract() {
    const config = new MatDialogConfig();
    config.data = {title: 'New Contract'};
    config.minHeight = '400px';
    config.width = '800px';
    config.panelClass = 'create-contract';

    const dialogRef = this.dialog.open(CreateContractComponent, config);

    dialogRef.afterClosed().subscribe(result => {
      if (result.isOk) {
        this.router.navigate(['/cedant/1/program/1/contract/0']);
      }
    });
  }

  isInfoOpen = false;

  toggleInfo() {
    this.isInfoOpen = !this.isInfoOpen;
  }

  isQuoteMenuOpen = false;

  toggleQuote() {
    this.isQuoteMenuOpen = !this.isQuoteMenuOpen;
  }

  onInfo() {
    this.flyoutTitle = 'Details';
  }

  onUsers() {
    this.flyoutTitle = 'Team';
  }

  onNotes() {
    this.flyoutTitle = 'Notes';
  }




}
